import { configureStore } from '@reduxjs/toolkit';

import { modalsReducer } from './modals';
import { instancesReducer } from './Instances';
import instanceReducer from './Instance/Reducer';
import themeReducer from './reducers/themeReducer';
import jobEditorReducer from './reducers/jobEditorReducer';
import menuJobIdReducer from './reducers/menuJobIdReducer';
import { orgMembersReducer } from './reducers/orgMembersReducer';
import { kanbanBoardReducer } from './reducers/kanbanBoardReducer';
import { jobWorkFlowReducer } from './reducers/jobWorkFlowReducer';

export const store = configureStore({
  reducer: {
    instances: instancesReducer,
    instance: instanceReducer,
    theme: themeReducer,
    jobEditor: jobEditorReducer,
    modals: modalsReducer,
    menuJobId: menuJobIdReducer,
    kanbanBoard: kanbanBoardReducer,
    jobWorkFlow: jobWorkFlowReducer,
    orgMembers: orgMembersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export all instances-related functionality
export * from './Instances';

export * from './Actions/themeActions';
// Export theme-related functionality
export * from './reducers/themeReducer'; 

// Export job editor-related functionality
export * from './Actions/jobEditorActions';
export * from './reducers/jobEditorReducer';
